if ($('.despre').length){

	function moveBottle(){
		if ($('.despre').length){
			if ( window.matchMedia("(max-width: 767px)").matches ) {
				$('.despre__bottle-image').css('transform','translateY(0px)');
			} else {
				var toscroll = $(window).scrollTop();
				var bottle = $('.despre__bottle').outerHeight() > $('.despre__bottle').outerWidth()*2.277372262773723 ? ( $('.despre__bottle').outerHeight() - $('.despre__bottle').outerWidth()*2.277372262773723)/2 : 0;
				var target = $('.despre-slide--blonda-image').offset().top - $('.despre__bottle').offset().top - ( ($('.despre__bottle-image').outerHeight() - $('.despre-slide--blonda-image').outerHeight()) > 0 ? ($('.despre__bottle-image').outerHeight() - $('.despre-slide--blonda-image').outerHeight()) : 0) + bottle;
				if ( toscroll < target )
					$('.despre__bottle-image').css('transform','translateY('+toscroll+'px)');
				else
					$('.despre__bottle-image').css('transform','translateY('+target+'px)');
			}
		}
	}

	//unevent js removed
	$(window).on('load scroll resize', function(e) {
		moveBottle();
	}/*, 150*/);

	$(document).ready(function() {
		$('a.despre__popover').click(function(e){
			e.preventDefault();
			if ( !$(this).hasClass('active') ) {
				$('a.despre__popover.active').not($(this)).removeClass('active').popover('destroy');
				$(this).addClass('active').popover({
					placement: 'right',
					trigger: 'manual',
					viewport:{ "selector": ".despre__timeline", "padding": 0 }
				}).popover('show');
			}
		});

		$('.despre-carousel').on('init setPosition',function(event, slick){
			if ( window.matchMedia("(max-width: 767px)").matches ) {
				var animation = new TimelineMax().fromTo('.slick-current .despre-slide--bottle',0.3,{y:'-100%',opacity:0,ease:Power2.easeOut},{y:'0%',opacity:1});
			}
		});
		$('.despre-carousel').slick({
			arrows:false,
			dots:true,
			swipe: false
		});
		var _nextslide;
		$('.despre-carousel').on('beforeChange',function(event, slick, currentSlide, nextSlide){
			_nextslide = currentSlide;
			if ( window.matchMedia("(min-width: 768px)").matches ) {
				$('.despre__bottle').fadeOut('200', function(){
					$('.despre__bottle-image').removeClass('despre__bottle-image'+currentSlide).addClass('despre__bottle-image'+nextSlide);
					$(this).fadeIn('250');
				});
			} else {
				$('.despre__bottle-image').removeClass('despre__bottle-image'+currentSlide).addClass('despre__bottle-image'+nextSlide);
			}
		});
		$('.despre-carousel').on('afterChange',function(event, slick, currentSlide){
			if ( window.matchMedia("(max-width: 767px)").matches && currentSlide != _nextslide ) {
				$('.despre-slide--bottle').removeAttr('style');
				var animation = new TimelineMax().fromTo('.slick-current .despre-slide--bottle',0.3,{y:'-100%',opacity:0,ease:Power2.easeOut},{y:'0%',opacity:1});
			}
		});

	});

}
